import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { toolsRouteRef, topologyRouteRef } from './routes';

export const exploreExtensionPlugin = createPlugin({
  id: 'appfolio-explore',
  routes: {
    tools: toolsRouteRef,
    topology: topologyRouteRef,
  },
});

export const ToolsPage = exploreExtensionPlugin.provide(
  createRoutableExtension({
    name: 'ToolsPage',
    component: () => import('./components/ToolsPage').then(m => m.ToolsPage),
    mountPoint: toolsRouteRef,
  }),
);

export const TopologyPage = exploreExtensionPlugin.provide(
  createRoutableExtension({
    name: 'TopologyPage',
    component: () =>
      import('./components/TopologyPage').then(m => m.TopologyPage),
    mountPoint: topologyRouteRef,
  }),
);
